export var MR_OAUTH_AUTHENTICATE_TYPE = 'mr_oauth/authenticate/status_changed';